import { useEffect, useState } from "react";
import { FILE_BASE_URL, getAppProjectsApi,deleteAppProjectApi, updateAppProjectApi} from "../../app/api";
import { useNavigate } from "react-router-dom";

import { createPortal } from "react-dom";

import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
export default function AppsListPage() {

  const navigate = useNavigate();
  const [selectedApp, setSelectedApp] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);



  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    app_name: "",
    server_ip: "",
    database_name: "",
  });

  useEffect(() => {
    fetchApps();
  }, []);

  const fetchApps = async () => {
    try {
      const res = await getAppProjectsApi();
      if (res.success) {
        setApps(res.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const filteredApps = apps.filter((a) => {
    return (
      a.app_name?.toLowerCase().includes(filters.app_name.toLowerCase()) &&
      a.server_ip?.toLowerCase().includes(filters.server_ip.toLowerCase()) &&
      a.database_name?.toLowerCase().includes(filters.database_name.toLowerCase())
    );
  });

  return (
    <div className="min-h-screen px-6 py-6 md:mt-24 bg-gradient-to-br from-[#140c2b] via-[#1f1147] to-[#0f0825] rounded-[20px]">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">

        <div>
          <h1 className="text-3xl text-white font-semibold">
            App Projects
          </h1>
          <p className="text-white/60 text-sm">
            Manage all apps
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-gray-700 text-white rounded-lg"
        >
          ← Back
        </button>

      </div>

      {/* FILTERS */}
      <div className="bg-white/5 border border-white/10 rounded-2xl p-4 mb-6">
        <div className="grid md:grid-cols-4 grid-cols-2 gap-4">

          <input
            placeholder="Search App Name"
            value={filters.app_name}
            onChange={(e)=>handleFilterChange("app_name", e.target.value)}
            className="px-3 py-2 rounded bg-white/10 text-white"
          />

          <input
            placeholder="Search Server IP"
            value={filters.server_ip}
            onChange={(e)=>handleFilterChange("server_ip", e.target.value)}
            className="px-3 py-2 rounded bg-white/10 text-white"
          />

          <input
            placeholder="Search DB Name"
            value={filters.database_name}
            onChange={(e)=>handleFilterChange("database_name", e.target.value)}
            className="px-3 py-2 rounded bg-white/10 text-white"
          />

          <button
            onClick={()=>setFilters({app_name:"",server_ip:"",database_name:""})}
            className="bg-blue-500 text-white rounded px-4"
          >
            Reset
          </button>

        </div>
      </div>

      {/* TABLE */}
      {/* <div className="bg-white/5 border border-white/10 rounded-2xl overflow-auto">

        {loading ? (
          <p className="p-6 text-white/60">Loading...</p>
        ) : (
          <table className=" text-white text-sm">

            <thead className="bg-white/10 text-xs uppercase">
              <tr> */}


<div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-lg overflow-auto mt-10 no-scrollbar">

{loading ? (
  <p className="p-6 text-white/60">Loading projects...</p>
) : (
  <table className="min-w-[1200px] text-sm text-left text-white">

    {/* HEADER */}
    <thead className="bg-white/10 text-white/80 text-xs uppercase whitespace-nowrap">
      <tr>
                <th className="px-2 py-3">ID</th>
                <th className="px-4 py-3">App Name</th>
                <th className="px-4 py-3">Platform</th>
                <th className="px-4 py-3">Server IP</th>
                <th className="px-4 py-3">DB Name</th>
                <th className="px-4 py-3">Code ZIP</th>
                <th className="px-4 py-3">Content</th>
                <th className="px-4 py-3">Policy URL</th>
                <th className="px-4 py-3">Description</th>
                <th className="px-4 py-3">Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredApps.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center py-6 text-white/60">
                    No apps found
                  </td>
                </tr>
              ) : (
                filteredApps.map((a) => (
                  <tr key={a.id} className="border-t border-white/10 whitespace-nowrap">
                    <td className="px-4 py-3">{a.id}</td>
                    <td className="px-4 py-3">{a.app_name}</td>
                    <td className="px-4 py-3">{formatAppPlatform(a.app_platform)}</td>
                    <td className="px-4 py-3">{a.server_ip}</td>
                    <td className="px-4 py-3">{a.database_name}</td>
                    <td className="px-4 py-3">
                      <FileLink app={a} />
                    </td>
                    <td className="px-4 py-3">{a.content}</td>
                    <td className="px-4 py-3">{a.policy_url}</td>
                    <td className="px-4 py-3">{a.description}</td>

                    <td className="px-4 py-3 flex gap-3">

  {/* EDIT */}
  <button
    onClick={() => {
      setSelectedApp(a);
      setShowEdit(true);
    }}
  >
    <PencilSquareIcon className="w-5 h-5 text-blue-400" />
  </button>

  {/* DELETE */}
  <button
    onClick={() => {
      setSelectedApp(a);
      setShowDelete(true);
    }}
  >
    <TrashIcon className="w-5 h-5 text-red-400" />
  </button>

</td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
        )}

      </div>




      {showDelete && (
  <div className="fixed inset-0 bg-black/50 flex justify-center items-center">
    <div className="bg-[#1f1147] p-6 rounded-xl text-center w-[300px]">

      <h2 className="text-white text-lg mb-2">
        Delete Project?
      </h2>

      <div className="flex justify-center gap-3 mt-4">
        <button
          onClick={() => setShowDelete(false)}
          className="px-4 py-2 bg-gray-500 rounded text-white"
        >
          Cancel
        </button>

        <button
          onClick={async () => {
            await deleteAppProjectApi(selectedApp.id);
            setShowDelete(false);
            fetchApps();
          }}
          className="px-4 py-2 bg-red-600 rounded text-white"
        >
          Delete
        </button>
      </div>

    </div>
  </div>
)}





{showEdit && (
  <EditAppModal
    app={selectedApp}
    onClose={() => setShowEdit(false)}
    onSuccess={() => {
      setShowEdit(false);
      fetchApps();
    }}
  />
)}




    </div>
  );
}



function EditAppModal({ app, onClose, onSuccess }) {

    const [form, setForm] = useState({ ...app, source_zip: null });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
  
    const handleChange = (key, value) => {
      setForm((prev) => ({ ...prev, [key]: value }));
    };
  
    const handleUpdate = async (e) => {
      e.preventDefault();
  
      try {
        setLoading(true);
  
        const payload = new FormData();
        Object.entries(form).forEach(([key, value]) => {
          if (key === "source_zip" && !value) return;
          if (value !== null && value !== undefined) {
            payload.append(key, value);
          }
        });

        const res = await updateAppProjectApi(app.id, payload);
  
        if (res.data) {
          setSuccess(true);
        }
  
      } catch (err) {
        alert(err.message);
      } finally {
        setLoading(false);
      }
    };
  


    // return createPortal(children, document.body);
 return createPortal(
  <>
    {/* BACKDROP */}
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50">

      {/* MODAL */}
      <div className="
        w-[700px] max-h-[90vh] overflow-y-auto
        rounded-2xl p-6
        bg-white/10 backdrop-blur-xl
        border border-white/20
        shadow-2xl
      ">

        <h2 className="text-white text-xl font-semibold mb-4">
          Edit App
        </h2>

        <form onSubmit={handleUpdate} className="space-y-4">

          {/* ✅ GRID FORM */}
          <div className="grid grid-cols-2 gap-4">

            <Input label="App Name"
              value={form.app_name}
              onChange={(v)=>handleChange("app_name", v)}
            />

            <Input label="Server IP"
              value={form.server_ip}
              onChange={(v)=>handleChange("server_ip", v)}
            />

            <Input label="Database Name"
              value={form.database_name}
              onChange={(v)=>handleChange("database_name", v)}
            />

            <Select label="App Platform"
              value={form.app_platform}
              options={[
                { label: "Select Platform", value: "" },
                { label: "Android App", value: "android" },
                { label: "iOS App", value: "ios" },
                { label: "Android & iOS App", value: "android_ios" },
              ]}
              onChange={(v)=>handleChange("app_platform", v)}
            />

            <Input label="Policy URL"
              value={form.policy_url}
              onChange={(v)=>handleChange("policy_url", v)}
            />

            <div className="col-span-2">
              <FileInput label="Replace Source Code ZIP"
                fileName={form.source_zip?.name}
                onChange={(file)=>handleChange("source_zip", file)}
              />
              {app.source_zip_path && (
                <p className="mt-1 text-xs text-white/50">
                  Current file: {app.source_zip_name || "Source Code ZIP"}
                </p>
              )}
            </div>

            {/* FULL WIDTH */}
            <div className="col-span-2">
              <Textarea label="Content"
                value={form.content}
                onChange={(v)=>handleChange("content", v)}
              />
            </div>

            <div className="col-span-2">
              <Textarea label="Description"
                value={form.description}
                onChange={(v)=>handleChange("description", v)}
              />
            </div>

          </div>

          {/* BUTTONS */}
          <div className="flex justify-end gap-3 pt-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-white/20 text-white hover:bg-white/30 transition"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-5 py-2 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-lg hover:scale-105 transition"
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>

        </form>
      </div>
    </div>

    {/* SUCCESS MODAL */}
    {success && (
      <div className="fixed inset-0 flex justify-center items-center bg-black/60 z-50">
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 p-6 rounded-xl text-center text-white">

          <h2 className="mb-3 text-lg font-semibold">
            ✅ Updated Successfully
          </h2>

          <button
            onClick={() => {
              setSuccess(false);
              onClose();
              onSuccess();
            }}
            className="px-4 py-2 bg-purple-600 rounded-lg"
          >
            OK
          </button>

        </div>
      </div>
    )}
  </>,
  document.body
);
        }



  function Input({ label, value, onChange, error, type = "text" }) {
    return (
      <div>
        <label className="text-sm text-white/60">{label}</label>
  
        <input
          type={type}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white"
        />
      </div>
    );
  }

  function Select({ label, value, onChange, options }) {
    return (
      <div>
        <label className="text-sm text-white/60">{label}</label>

        <select
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value} className="bg-[#1f1147] text-white">
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  function FileInput({ label, fileName, onChange }) {
    return (
      <div>
        <label className="text-sm text-white/60">{label}</label>

        <input
          type="file"
          accept=".zip"
          onChange={(e) => onChange(e.target.files?.[0] || null)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white file:mr-4 file:rounded-lg file:border-0 file:bg-indigo-600 file:px-3 file:py-2 file:text-white"
        />
        {fileName && (
          <p className="mt-1 text-xs text-white/50">{fileName}</p>
        )}
      </div>
    );
  }
  
  function Textarea({ label, value, onChange }) {
    return (
      <div>
        <label className="text-sm text-white/60">{label}</label>
  
        <textarea
          rows={3}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white"
        />
      </div>
    );
  }

function formatAppPlatform(platform) {
  const labels = {
    android: "Android App",
    ios: "iOS App",
    android_ios: "Android & iOS App",
  };

  return labels[platform] || platform || "N/A";
}

function FileLink({ app }) {
  const path = app.source_zip_path || app.code_zip_path || app.source_zip;
  const name = app.source_zip_name || app.code_zip_name || "Source Code ZIP";

  if (!path) return <span className="text-white/40">N/A</span>;

  const href = /^https?:\/\//i.test(path)
    ? path
    : `${FILE_BASE_URL}${path.startsWith("/") ? "" : "/"}${path}`;

  return (
    <a href={href} target="_blank" rel="noreferrer" className="text-cyan-300 hover:underline">
      {name}
    </a>
  );
}
